import axios from 'axios'

export const API_ORIGIN = process.env.REACT_APP_API_ORIGIN || 'http://localhost:8000'

// Arquivos públicos do Laravel (storage link). Em produção, se o docroot
// não for a pasta public/, defina REACT_APP_PUBLIC_URL (ex: https://api.perifasul.org/public/).
export const URL_PUBLIC = process.env.REACT_APP_PUBLIC_URL || `${API_ORIGIN}/`

const baseURL = `${API_ORIGIN}/api/v1/`

export const api = axios.create({ baseURL })

export const getSimpleConfigApi = () => {
    return {
        headers: {
            Accept: 'application/json',
        }
    }
}

export const getConfigApi = () => {
    const localStorageKeys = Object.keys(localStorage)
    let token = ''

    if (localStorageKeys.includes('usuario')) {
        token = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario') || '{}')?.authorisation.token : ''
    } else if (localStorageKeys.includes('authentication-admin')) {
        token = localStorage.getItem('authentication-admin') ? JSON.parse(localStorage.getItem('authentication-admin') || '{}').authorisation.token : ''
    }

    return {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json"
        }
    }
}

export const getConfigApiNoAccept = () => {
    const localStorageKeys = Object.keys(localStorage)
    let token = ''

    if (localStorageKeys.includes('usuario')) {
        token = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario') || '{}')?.authorisation.token : ''
    } else if (localStorageKeys.includes('authentication-admin')) {
        token = localStorage.getItem('authentication-admin') ? JSON.parse(localStorage.getItem('authentication-admin') || '{}').authorisation.token : ''
    }

    return {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json"
        }
    }
}